import DocsSource from './DocsSource';

const branchBlacklist = ['docs'];

export default new DocsSource({
  id: 'main',
  name: 'Main library',
  global: 'fnbr.js',
  repo: 'fnbrjs/fnbr.js',
  defaultTag: 'stable',
  branchFilter: branch => !branchBlacklist.includes(branch) && !branch.startsWith('dependabot'),
});
